import  {   HttpHeaders 
        ,   HttpParams          } from "@angular/common/http";
import  {   Injectable          } from "@angular/core";
import { MediaAPI } from "src/app/enums/network/request/media/media.api";
import { MediaField } from "src/app/enums/network/request/media/media.fields";
import { NetworkManager } from "src/app/managers/network/network.manager";

@Injectable
({
  providedIn: 'root'
})
export class MediaRequest
{
    constructor(
        private _network: NetworkManager
    ){}

    public upload_image(
        token       : string     
    ,   level       : string
    ,   levelid     : number
    ,   type        : string
    ,   code        : string
    ,   file        : File       
    ,   description : string 
    ){
      const  url = this._network.MediaApi() + MediaAPI.UPLOAD_LEVEL_IMAGE .replace('{level}'  , level             )
                                                                          .replace('{levelId}', levelid.toString())

      const headers = new HttpHeaders() .append( MediaField.TOKEN, token )
      
      const form = new FormData()
      form.append( MediaField.DESCRIPTION      , description           );
      form.append( MediaField.TYPE             , type                  );
      form.append( MediaField.CODE             , code                  );
      form.append( MediaField.FILE             , file                  );


      return this._network.http().post( url, form, { headers } ).toPromise()
    }

    public async recoveryMediaByUUID ( 
      uuid: string 
    ){
      const  url = this._network.MediaApi() + MediaAPI.GET_MEDIA_BY_UUID .replace('{uuid}'  , uuid )

      console.log( url );
      
      return this._network.http().get( url , { responseType: 'blob' }).toPromise()
    } 

    public async recoveryMediaData( 
      token   : string
    , level   :   string
    , levelid :   number
    , type    :   string
    , code    :   string
    ){
      const  url = this._network.MediaApi() + MediaAPI.GET_DATA_BY_LEVEL

      const headers = new HttpHeaders() .append( MediaField.TOKEN, token )

      const form = new URLSearchParams();
      form.append( MediaField.LEVEL            , level                  );
      form.append( MediaField.LEVELID          , levelid.toString()     );
      form.append( MediaField.TYPE             , type                   );
      form.append( MediaField.CODE             , code                   );

      return this._network.http().put( url , form.toString() , { headers }).toPromise()
    }

    public async deleteByType( 
      token   : string
    , level   :   string
    , levelid :   number
    , type    :   string
    , code    :   string
    ){
      const  url = this._network.MediaApi() + MediaAPI.DELETE_BY_TYPE

      const headers = new HttpHeaders() .append( MediaField.TOKEN, token )

      const form = new URLSearchParams();
      form.append( MediaField.LEVEL            , level                  );
      form.append( MediaField.LEVELID          , levelid.toString()     );
      form.append( MediaField.TYPE             , type                   );
      form.append( MediaField.CODE             , code                   );

      return this._network.http().put( url , form.toString() , { headers } ).toPromise()
    }
}